export default __webpack_public_path__ + "static/media/Ballroll_00302.f1a26219.png";